(() => {
  const HEADER_SELECTOR =
    '.shopify-section-group-header-group .fixed[class*="header-"]';
  const ROOT_CLASS = 'hellomatcha-fixed-header';
  const MAIN_CLASS = 'hellomatcha-header-offset';
  const OVERLAY_CLASS = 'hellomatcha-header-overlay';
  const OFFSET_VARIABLE = '--hellomatcha-header-offset';
  const HERO_MARKERS = [
    'ss_hero',
    'ss-hero',
    'image_banner',
    'image-banner',
    'video_hero',
    'video-hero',
    'videobanner',
    'slideshow',
    'hero_banner',
    'hero-banner'
  ];
  const HERO_CONTENT_SELECTOR = [
    '.banner',
    '.slideshow',
    '.collection-hero',
    '.email-signup-banner',
    '[class*="hero-"]',
    '[class*="-hero"]',
    '[class*="hero_"]',
    '[class*="_hero"]',
    '[class*="videobanner"]'
  ].join(',');

  let observedHeader;
  let headerResizeObserver;
  let mainMutationObserver;

  const getMain = () => document.getElementById('MainContent');

  const getFirstVisibleSection = (main) =>
    Array.from(main.children).find((element) => {
      const style = getComputedStyle(element);
      return (
        style.display !== 'none' &&
        style.visibility !== 'hidden' &&
        element.getAttribute('aria-hidden') !== 'true'
      );
    });

  const hasOpeningHero = (main) => {
    const firstSection = getFirstVisibleSection(main);
    if (!firstSection) return false;

    const signature = `${firstSection.id} ${
      typeof firstSection.className === 'string'
        ? firstSection.className
        : ''
    }`.toLowerCase();

    return (
      HERO_MARKERS.some((marker) => signature.includes(marker)) ||
      Boolean(firstSection.querySelector(HERO_CONTENT_SELECTOR))
    );
  };

  const observeHeader = (header) => {
    if (!('ResizeObserver' in window) || header === observedHeader) return;

    headerResizeObserver?.disconnect();
    observedHeader = header;
    headerResizeObserver = new ResizeObserver(updateHeaderOffset);
    headerResizeObserver.observe(header);
  };

  const resetOffset = (main) => {
    document.documentElement.style.removeProperty(OFFSET_VARIABLE);
    document.documentElement.classList.remove(ROOT_CLASS);
    main.classList.remove(MAIN_CLASS, OVERLAY_CLASS);
  };

  const updateHeaderOffset = () => {
    const main = getMain();
    if (!main) return;

    const header = document.querySelector(HEADER_SELECTOR);

    if (!header) {
      resetOffset(main);
      headerResizeObserver?.disconnect();
      observedHeader = undefined;
      return;
    }

    observeHeader(header);

    const headerStyle = getComputedStyle(header);
    const isOutOfFlow =
      headerStyle.position === 'fixed' || headerStyle.position === 'absolute';
    const useOverlay =
      main.dataset.templateName === 'index' || hasOpeningHero(main);

    const marginTop = Number.parseFloat(headerStyle.marginTop) || 0;
    const marginBottom = Number.parseFloat(headerStyle.marginBottom) || 0;
    const offset = isOutOfFlow && !useOverlay
      ? Math.max(0, Math.ceil(header.offsetHeight + marginTop + marginBottom))
      : 0;

    document.documentElement.style.setProperty(
      OFFSET_VARIABLE,
      `${offset}px`
    );
    document.documentElement.classList.toggle(ROOT_CLASS, offset > 0);
    main.classList.toggle(MAIN_CLASS, offset > 0);
    main.classList.toggle(OVERLAY_CLASS, isOutOfFlow && useOverlay);
  };

  const start = () => {
    updateHeaderOffset();

    const main = getMain();
    if ('MutationObserver' in window && main) {
      mainMutationObserver = new MutationObserver(updateHeaderOffset);
      mainMutationObserver.observe(main, { childList: true });
    }

    window.addEventListener('resize', updateHeaderOffset, { passive: true });
    window.addEventListener('load', updateHeaderOffset, { once: true });

    if (document.fonts?.ready) {
      document.fonts.ready.then(updateHeaderOffset);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', updateHeaderOffset);
  document.addEventListener('shopify:section:unload', () => {
    requestAnimationFrame(updateHeaderOffset);
  });
})();
